import React from 'react';

import { SliderProps } from 'rc-slider/lib/Slider';
import { Tooltip, ITooltip } from 'react-tooltip';

export type TooltipRender = SliderProps['handleRender'];

export function getTooltipRender(
  sliderId: string,
  tipFormatter?: (value: number) => React.ReactNode,
  tipProps?: ITooltip,
  alwaysShowTooltip?: boolean,
) {
  const render: TooltipRender = (node, handleProps) => {
    const formatter = tipFormatter || ((value: number) => value.toString());
    return (
      <>
        {node}
        <Tooltip
          className="bg-transparent border-none text-brand-600"
          {...tipProps}
          anchorSelect={`#${sliderId} .rc-slider-handle-${handleProps.index + 1}`}
          place="top"
          offset={1}
          isOpen={alwaysShowTooltip || handleProps.dragging}
        >
          {formatter(handleProps.value)}
        </Tooltip>
      </>
    );
  };

  return render;
}
